

export const _maintenanceContractClass = {
  name: {
    type: 'string',
    title: 'Nimi',
  },
  description: {
    type: 'string',
    title: 'Kuvaus',
  },
  customerid: {
    type: 'string',
    title: 'Asiakas',
  },
  validuntil: {
    type: 'string',
    format: 'date',
    title: 'Voimassa',
  },
  status: {
    type: 'string',
    title: 'Status',
    oneOf: [
      { const: 'active', title: 'Aktiivinen' },
      { const: 'inactive', title: 'Ei aktiivinen' },
    ],
  },
}


export const _maintenanceContractClassDeps = {
}

export const _maintenanceContractUISchema = {
  status: {
    'ui:widget': 'radio',
  },
}


export const _maintenanceServicedescriptionClass = {
  name: {
    type: 'string',
    title: 'Nimi',
  },
  description: {
    type: 'string',
    title: 'Kuvaus',
  },
  taskgroups: {
    title: '',
    description: 'taskiryhmät',
    type: 'array',
    items: {
      type: 'object',
      properties: {
        name: { type: 'string', title: 'Nimi' },
        description: { type: 'string', title: 'Kuvaus' },
      },
    },
  },
}

export const _maintenanceServicedescriptionClassDeps = {
}

export const _maintenanceServicedescriptionUISchema = {
  description: {
    'ui:widget': 'editorWidget',
  },
}


export const _maintenanceTaskgroupClass = {
  name: {
    type: 'string',
    title: 'Nimi',
  },
  description: {
    type: 'string',
    title: 'Kuvaus',
  },
  taskids: {
    type: 'array',
    title: 'Tehtävät',
    items: {
      type: 'string',
      oneOf: [],
    },
    uniqueItems: true,
  },
}

export const _maintenanceTaskgroupClassDeps = {
  taskids: {
    oneOf: [
      {
        properties: {
          taskids: {
            enum: [],
          },
        },
      },
    ],
  },
}

export const _maintenanceTaskgroupUISchema = {
  taskids: {
    'ui:widget': 'checkboxes',
  },
}


export const _maintenanceTicketClass = {
  message: {
    type: 'string',
    title: 'Viesti',
    readOnly: true,
  },
  email: {
    type: 'string',
    title: 'Raportoinut',
    readOnly: true,
  },
  class: {
    type: 'string',
    title: 'Luokka',
    oneOf: [],
  },
  image: {
    type: 'string',
    title: 'Kuva',
    readOnly: true,
  },
  priority: {
    type: 'string',
    title: 'Prioriteetti',
    oneOf: [
      { const: 'low', title: 'Matala' },
      { const: 'normal', title: 'Normaali' },
      { const: 'high', title: 'Korkea' },
    ],
  },
  target: {
    type: 'string',
    title: 'Kohde',
    oneOf: [],
  },
  notes: {
    title: '',
    description: 'muistiinpanot',
    type: 'array',
    items: {
      type: 'object',
      properties: {
        note: { type: 'string', title: 'Teksti' },
      },
    },
  },
  status: {
    type: 'string',
    title: 'Status',
    oneOf: [
      { const: 'closed', title: 'Suljettu (ei toimenpiteitä)' },
      { const: 'new', title: 'Uusi' },
      { const: 'inprogress', title: 'Käsittelyssä' },
      { const: 'completed', title: 'Valmis' },
    ],
    readOnly: true,
  },
  createdDate: {
    type: 'string',
    format: 'date',
    title: 'Luotu',
    readOnly: true,
  },
  updatedDate: {
    type: 'string',
    format: 'date',
    title: 'Päivitetty',
    readOnly: true,
  },

}

export const _maintenanceTicketClassDeps = {
}

export const _maintenanceTicketUISchema = {
  status: {
    'ui:widget': 'radio',
  },
  message: {
    "ui:widget": "textarea",
    "ui:options": {
      "rows": 10
    }
  },
  image: {
    'ui:widget': 'imageViewerWidget',
  },
}


export const _maintenancePlanTaskClass = {
  action: {
    type: 'string',
    title: 'Toimenpide',
  },
  target: {
    type: 'string',
    title: 'Kohde',
    oneOf: [],
  },
  detailedtarget: {
    type: 'string',
    title: 'Tarkempi kohde. Esim. huoneisto tai laite',
  },
  frequency: {
    type: 'string',
    title: 'Tiheys',
    oneOf: [
      { const: 'weekly', title: 'Viikoittain' },
      { const: 'biweekly', title: 'Kahden viikon välein' },
      { const: 'monthly', title: 'Kuukausittain' },
      { const: 'quarterly', title: 'Neljännesvuosittain' },
      { const: 'semiannually', title: 'Puolivuosittain' },
      { const: 'annually', title: 'Vuosittain' },
      { const: 'biennially', title: 'Kahden vuoden välein' },
    ],
  },
  startdate: {
    type: 'string',
    format: 'date',
    title: 'Aloituspäivämäärä',
  },
  lastcompletiondate: {
    type: 'string',
    format: 'date',
    title: 'Viimeisin valmistumispäivämäärä',
  },
  notes: {
    type: 'string',
    title: 'Muistiinpanot',
  },
  responsible: {
    type: 'string',
    title: 'Vastuullinen',
  }
}

export const _maintenancePlanTaskUISchema = {
  notes: {
    "ui:widget": "textarea",
    "ui:options": {
      "rows": 5
    }
  },
}

export const _maintenancePlanTaskExecutionClass = {
  note: {
    type: 'string',
    title: 'Muistiinpano',
  },
  date: {
    type: 'string',
    format: 'date',
    title: 'Päivämäärä',
  },
  completedBy: {
    type: 'string',
    title: 'Suorittaja',
  },
  plantaskid: {
    type: 'string',
    title: 'Huoltotehtävä id',
  },
}

export const _maintenancePlanTaskExecutionUISchema = {
  note: {
    "ui:widget": "textarea",
    "ui:options": {
      "rows": 5
    }
  },
  plantaskid: {
    'ui:widget': 'hidden',
  },
}